import axios from "../../index";
import { jobRequestUrl } from "../../utils";

export const deleteJobRequest = async (jobRequestId: string) => {
  return await axios.delete(jobRequestUrl(jobRequestId));
};
